import { useTranslation } from "react-i18next";
import { Heading, Text } from "@ttc3k/trekker";
import { Flex } from "styled-system/jsx";
import { useOnboardingContext } from "onboarding/OnboardingContext.tsx";
import { getMultilingualString } from "shared/utils";
import { ControlledInput } from "shared/components";
import { EnumUserStatus } from "gql/generated.ts";

export const AccountScreen = () => {
  const { t } = useTranslation("onboarding");
  const { organization, isInvited, user } = useOnboardingContext();
  const isUserCreating =
    (!!user && user.status !== EnumUserStatus.Enrolled) || !user;

  return (
    <>
      <Flex flexDir={"column"} gap={"150"}>
        <Heading size={"h4"}>
          {t(`ACCOUNT_SCREEN.${isUserCreating ? "CREATE" : "UPDATE"}`)}
        </Heading>
      </Flex>
      <Text color={"text.mid"} textAlign={"center"}>
        {t("ACCOUNT_SCREEN.DESCRIPTION", {
          organizationName: getMultilingualString(organization?.name ?? {}),
        })}
      </Text>
      <Flex flexDir={"column"} gap={"150"} w={"full"}>
        <Flex gap={"150"}>
          <ControlledInput name={"firstName"} label={t("FORM.FIRST_NAME")} />
          <ControlledInput name={"lastName"} label={t("FORM.LAST_NAME")} />
        </Flex>
        <ControlledInput
          name={"email"}
          label={t("FORM.EMAIL")}
          disabled={isInvited}
          type="email"
        />
      </Flex>
    </>
  );
};
